import { Money } from "ts-money";
import { calculatePercentage } from "@utilities/calculate-percentage";
export class BudgetAnalytics {
    totalBudgetAvailable;
    budgetAvailable;
    constructor(totalBudgetAvailable, budgetAvailable) {
        this.totalBudgetAvailable = totalBudgetAvailable;
        this.budgetAvailable = budgetAvailable;
    }
    budgetSpent() {
        return new Money(this.totalBudgetAvailable.amount - this.budgetAvailable.amount, this.totalBudgetAvailable.currency);
    }
    /**
     * Calculates the percentage for spend budget
     * @returns Rounded percentage number for spend budget
     */
    spendBudgetPercentage() {
        return calculatePercentage(this.totalBudgetAvailable.amount, this.budgetSpent().amount);
    }
}
